import React from "react";

export default function StatCard({ label, value, sub, color = "#e2e8f0", accent = "#1e293b", icon }) {
  return (
    <div style={{
      background: "#060d1a",
      border: `1px solid ${accent}`,
      borderRadius: 10,
      padding: "16px 18px",
      display: "flex",
      flexDirection: "column",
      gap: 6,
      position: "relative",
      overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0, height: 2,
        background: `linear-gradient(90deg, ${color}44, transparent)`,
      }} />
      <div style={{ fontSize: 10, color: "#475569", letterSpacing: "0.1em", fontWeight: 500, display: "flex", alignItems: "center", gap: 6 }}>
        {icon && <span>{icon}</span>}
        {label}
      </div>
      <div style={{ fontSize: 22, fontWeight: 700, color, fontFamily: "'Syne', sans-serif", letterSpacing: "-0.02em" }}>
        {value}
      </div>
      {sub && <div style={{ fontSize: 10, color: "#64748b" }}>{sub}</div>}
    </div>
  );
}
